import(/* webpackMode: "eager", webpackExports: ["MotionDiv"] */ "/vercel/path0/components/motion/MotionDiv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionH1"] */ "/vercel/path0/components/motion/MotionH1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionP"] */ "/vercel/path0/components/motion/MotionP.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionSpan"] */ "/vercel/path0/components/motion/MotionSpan.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/town.svg");
